<template>
  <div>
    <template v-if="data && data.length">
      <a-table
        :columns="columnsFiles"
        :data-source="data"
        :showHeader="false"
        :pagination="false"
        :loading="loadingDocument"
      >
        <template #title>
          <a-typography-text style="color: #475569; display: block">
            {{ title }}
          </a-typography-text>
        </template>

        <template #name="{ text }">
          <a-typography-text class="text-gray-8">
            {{ text }}
          </a-typography-text>
        </template>

        <template #ver="{ text, record }">
          <span>
            <a :href="record.route" target="_blank" rel="noreferrer noopener">
              {{ text }}
            </a>
          </span>
        </template>
      </a-table>
    </template>

    <template v-else>
      <a-collapse v-model:activeKey="activeKey" class="mb-2">
        <a-collapse-panel :key="1" :header="title">
          <a-typography-text style="color: #475569">
            No hay archivos para este ticket.
          </a-typography-text>
        </a-collapse-panel>
      </a-collapse>
    </template>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { GET_LOGGED_USER } from '../../store/types';

export default {
  name: 'DocumentosAdjuntos',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    loadingDocument: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore();
    const activeKey = ref([]);
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    const columnsFiles = [
      {
        dataIndex: 'name',
        width: 200,
        slots: { customRender: 'name' }
      }
    ];

    if (userRole !== 'rrhh') {
      columnsFiles.push({
        dataIndex: 'ver',
        width: 100,
        align: 'right',
        slots: { customRender: 'ver' }
      });
    }

    return {
      columnsFiles,
      activeKey
    };
  }
};
</script>
